import React from "react";
import Construction from "./pages/Construction";

const App = () => <Construction />;

export default App;
